define('modules/player/player_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/ads/ads_collection',
  './media/central/central_media_collection',

  'modules/loading/loading_spinner_view',
  'modules/util/collection/collection_view',
  'modules/player/media/central/central_media_collection_item_view',
  'modules/player/media/local/zone_media_collection_item_view',

  'text!./player_template.html',
  'text!./zone_media_list_actions_template.html',
], function (
  Backbone,
  $,
  _,
  session,
  ZoneMediaCollection,
  PlayerCentralMediaCollection,
  Loading,
  CollectionView,
  CentralMediaCollectionItemView,
  ZoneMediaCollectionItemView,
  player_template,
  zone_media_list_actions_template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.subViews = [];

      this.render();

      this.zone_media_collection = new ZoneMediaCollection();
      this.zone_media_collection.params = _.extend(
        this.zone_media_collection.params,
        {
          zone: this.zone_id,
          location_id: session.get('location_id'),
          player_id: this.player_id,
        }
      );

      this.central_media_collection = new PlayerCentralMediaCollection({
        player_id: this.player_id,
        zone_id: this.zone_id,
      });

      var loading = new Loading();
      this.subViews.push(loading);

      this.listenTo(
        this.zone_media_collection,
        'request',
        loading.start.bind(loading)
      );
      this.listenTo(
        this.central_media_collection,
        'request',
        loading.start.bind(loading)
      );

      this.listenTo(
        this.zone_media_collection,
        'sync',
        function (model) {
          loading.done();
          this.renderZoneList();
        },
        this
      );

      this.listenTo(
        this.central_media_collection,
        'sync',
        function (model) {
          loading.done();
          this.renderCentralList();
        },
        this
      );

      this.zone_media_collection.fetch();
    },

    hasSidebar: false,
    subViews: [],

    template: _.template(player_template),
    zone_media_list_actions_template: _.template(
      zone_media_list_actions_template
    ),

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderZoneList: function () {
      var zoneList = new CollectionView({
        items: this.zone_media_collection,
        itemView: ZoneMediaCollectionItemView,
        options: {
          search: false,
        },
        extraParams: {
          zone_id: this.zone_id,
        },
      });

      this.$('.js-player-list').html(zoneList.$el);
      this.$('.js-player-list').append(
        this.zone_media_list_actions_template({ zone_id: this.zone_id })
      );
      this.subViews.push(zoneList);

      return this;
    },

    renderCentralList: function () {
      var centralList = new CollectionView({
        items: this.central_media_collection,
        itemView: CentralMediaCollectionItemView,
        options: {
          search: false,
        },
      });

      this.$('.js-player-list').html(centralList.$el);
      this.subViews.push(centralList);

      return this;
    },

    switchView: function (media_type) {
      if (media_type === 'central_media') {
        this.central_media_collection.fetch();
      } else {
        this.zone_media_collection.fetch();
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

